import { render, staticRenderFns } from "./kioskSimulator.vue?vue&type=template&id=808b6b1c&scoped=true"
import script from "./kioskSimulator.vue?vue&type=script&lang=js"
export * from "./kioskSimulator.vue?vue&type=script&lang=js"
import style0 from "./kioskSimulator.vue?vue&type=style&index=0&id=808b6b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808b6b1c",
  null
  
)

export default component.exports